import React, { Component } from 'react';

import sentry from 'services/Sentry/SentryInstance';

import GlobalErrorModal from 'modals/GlobalErrorModal';

import { IProps, IState } from './types';

// TODO: https://welltech.atlassian.net/browse/UPP-93
enum ERROR_LEVELS {
  CRITICAL = 'fatal',
  ERROR = 'error',
  WARNING = 'warning',
}
const SENTRY_APP = 'APP';

class ErrorBoundary extends Component<IProps, IState> {
  public state: IState = { hasError: false, error: null };

  public static getDerivedStateFromError(): IState {
    return { hasError: true };
  }

  public logError(error: Error) {
    sentry.logError(error, SENTRY_APP, ERROR_LEVELS.CRITICAL);
  }

  public componentDidCatch(error: Error) {
    this.setState({ error });

    this.logError(error);
  }

  public render() {
    if (this.state.hasError) {
      return <GlobalErrorModal isOpen={true} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
